import {
    getOriginColor,
    getOriginList,
    getCriticalityColor,
    getTypeObjectList,
} from 'qa/src/queries/qa';
import { nameToString, IconName } from 'sdi/components/button/names';
import { DIV, SPAN } from 'sdi/components/elements';
import tr from 'sdi/locale';
import { getLegendSymbology, LegendSelector } from 'qa/src/queries/map';
import { setLegendSymbology } from 'qa/src/events/map';
import { iconNameForObject } from 'qa/src/queries/map/style';

const wrapItem = (
    color: string,
    label: string,
    iconName = 'circle' as IconName
) =>
    DIV(
        { className: 'legend-item' },
        DIV(
            {
                className: 'fa icon item-style',
                style: {
                    color,
                    fontSize: '12pt',
                },
            },
            nameToString(iconName)
        ),
        DIV({ className: 'item-label' }, label)
    );

const renderLegendObjectItems = () =>
    getTypeObjectList().map(o =>
        wrapItem('grey', tr.qa(o), iconNameForObject(o))
    );

const renderLegendTypologyItems = () =>
    getOriginList().map(origin =>
        wrapItem(getOriginColor(origin), tr.qa(origin))
    );

export const renderLegendTypology = () =>
    DIV(
        { className: 'legend-group named' },
        DIV({ className: 'legend-group-items' }, ...renderLegendTypologyItems())
    );

export const renderLegendPriority = () =>
    DIV(
        { className: 'legend-group named' },
        DIV(
            { className: 'legend-group-items' },
            wrapItem(getCriticalityColor('high'), tr.qa('high')),
            wrapItem(getCriticalityColor('medium'), tr.qa('medium')),
            wrapItem(getCriticalityColor('low'), tr.qa('low'))
        )
    );

export const renderLegendObjects = () =>
    DIV(
        { className: 'legend-group named' },
        DIV({ className: 'legend-group-items' }, ...renderLegendObjectItems())
    );

const isLegendActive = (symbology: LegendSelector) =>
    getLegendSymbology() === symbology ? 'active' : 'inactive';

export const renderLegendSwitch = () =>
    DIV(
        { className: 'tab-title-switch' },
        SPAN(
            {
                className: `tab-title typology ${isLegendActive('typology')}`,
                onClick: () => setLegendSymbology('typology'),
            },
            tr.qa('selectTypology')
        ),
        SPAN(
            {
                className: `tab-title priority ${isLegendActive('priority')}`,
                onClick: () => setLegendSymbology('priority'),
            },
            tr.qa('selectPriority')
        ),
        SPAN(
            {
                className: `tab-title objects ${isLegendActive('objects')}`,
                onClick: () => setLegendSymbology('objects'),
            },
            tr.qa('selectObjects')
        )
    );
// {
//     const s = getLegendSymbology();
//     switch (s) {
//         case 'priority':
//             return DIV({ className: 'tab-title-switch' },
//                 SPAN({ className: 'tab-title active' }, tr.qa('selectPriority')),
//                 SPAN({
//                     className: 'tab-title',
//                     onClick: () => setLegendSymbology('typology'),
//                 }, tr.qa('selectTypology')),
//                 SPAN({
//                     className: 'tab-title',
//                     onClick: () => setLegendSymbology('objects'),
//                 }, tr.qa('selectObjects')),
//             );
//         case 'typology':
//             return DIV({ className: 'sidebar-tab__wrapper' },
//                 SPAN({
//                     className: 'tab-title',
//                     onClick: () => setLegendSymbology('priority'),
//                 }, tr.qa('selectPriority')),
//                 SPAN({ className: 'tab-title active ' }, tr.qa('selectTypology')),
//                 SPAN({
//                     className: 'tab-title',
//                     onClick: () => setLegendSymbology('objects'),
//                 }, tr.qa('selectObjects')),
//             );
//         case 'objects':
//             return DIV({ className: 'sidebar-tab__wrapper' },
//                 SPAN({
//                     className: 'tab-title',
//                     onClick: () => setLegendSymbology('priority'),
//                 }, tr.qa('selectPriority')),
//                 SPAN({
//                     className: 'tab-title',
//                     onClick: () => setLegendSymbology('typology'),
//                 }, tr.qa('selectTypology')),
//                 SPAN({ className: 'tab-title active ' }, tr.qa('selectObjects')),
//             );
//     }
// };

export const renderLegendBody = () => {
    const s = getLegendSymbology();
    switch (s) {
        case 'priority':
            return renderLegendPriority();
        case 'typology':
            return renderLegendTypology();
        case 'objects':
            return renderLegendObjects();
    }
};
